export default __webpack_public_path__ + "static/media/bgBackgroundPuspenerbalMap_2.ed30357a.png";